"use client";
import { useDialect } from "@/hooks/useDialect";
import { DialectSelectorContent } from "./DialectSelectorContent";
import { Modal } from "./Modal";

export const DialectSelectorPopup = ({
  isOpen,
  setIsOpen,
  dialect,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dialect: string;
}) => {
  const { availableDialects } = useDialect();

  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {
        setIsOpen(false);
      }}
    >
      <div className="!w-[90vw] rounded-[10px] border-[3px] border-stg-element-border-grey bg-stg-black-light px-4 py-8 md:!w-auto">
        <DialectSelectorContent
          dialect={dialect}
          availableDialects={availableDialects}
          onRequestClose={() => setIsOpen(false)}
        />
      </div>
    </Modal>
  );
};
